import { render } from "./kalio-copy-text-button.vue?vue&type=template&id=9ab465ac"
import script from "./kalio-copy-text-button.vue?vue&type=script&lang=js"
export * from "./kalio-copy-text-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__